import React from 'react';
import { FaBuilding, FaStethoscope, FaMoneyBillWave, FaShoppingCart, FaIndustry } from 'react-icons/fa';
import { SolutionData, SolutionsContent } from '../types';

export const solutionsContent: SolutionsContent = {
  heading: 'Industry Solutions',
  description: 'Our agentic systems are designed to address specific challenges across various industries, delivering tailored solutions that drive innovation and efficiency.'
};

export const solutions: SolutionData[] = [
  {
    title: "Enterprise Operations",
    description: "Transform your operational efficiency with intelligent agentic systems that streamline processes, reduce costs, and enable 24/7 autonomous operations.",
    icon: React.createElement(FaBuilding),
    benefits: [
      "Automate complex decision-making processes",
      "Reduce operational costs by up to 30%",
      "Enable 24/7 autonomous operations without human intervention"
    ]
  },
  {
    title: "Healthcare Solutions",
    description: "Enhance patient care and operational efficiency with agentic systems that assist in diagnostics, treatment planning, and administrative tasks.",
    icon: React.createElement(FaStethoscope),
    benefits: [
      "Reduce diagnostic errors through multi-agent verification",
      "Accelerate treatment planning with comprehensive data analysis",
      "Streamline administrative tasks for healthcare providers"
    ]
  },
  {
    title: "Financial Services",
    description: "Leverage intelligent agents for risk assessment, fraud detection, and personalized financial advice, enhancing both security and customer experience.",
    icon: React.createElement(FaMoneyBillWave),
    benefits: [
      "Identify fraudulent activities with 95% accuracy",
      "Deliver personalized financial recommendations at scale",
      "Automate regulatory compliance monitoring and reporting"
    ]
  },
  {
    title: "Retail & E-commerce",
    description: "Revolutionize your retail operations with agents that optimize inventory, personalize shopping experiences, and provide intelligent customer service.",
    icon: React.createElement(FaShoppingCart),
    benefits: [
      "Optimize inventory management to reduce waste by 25%",
      "Create hyper-personalized shopping experiences",
      "Handle 80% of customer service inquiries autonomously"
    ]
  },
  {
    title: "Manufacturing",
    description: "Enhance your production efficiency with intelligent agents that optimize supply chains, predict maintenance needs, and ensure quality control.",
    icon: React.createElement(FaIndustry),
    benefits: [
      "Reduce downtime through predictive maintenance",
      "Optimize supply chain logistics in real-time",
      "Ensure quality control with continuous autonomous monitoring"
    ]
  },
];